import history from 'components/history'
import firebase from 'firebase'
import { auth, ref } from 'constants/firebase'
import { authDataAction, setInitialized } from 'actions/authAC'
import { receiveReferences } from 'actions/referencesAC'
import { fetchPlans } from './plans'
import { fetchUser, cancelUserListener } from './user'
import { setLastApp } from 'actions/lastAppAC'
import { authAnonymously } from './auth'
import _ from 'lodash'
import co from 'co'

function * onAuthStateChanged (authData, dispatch, getState) {
  console.log('onAuthStateChanged', authData, history.location)
  try {
    if (authData) {
      if (history.location.pathname === '/shopify-app' && authData.isAnonymous) {
        console.log('user', authData.uid, 'is anonymous, this is not allowed for /shopify-app')
        dispatch(authDataAction({}))
        return
      }
      const state = getState()
      const oldAuthData = state.authData
      if (oldAuthData.id && oldAuthData.isAnonymous) {
        console.log('oldAuthData exists', oldAuthData)
        // MERGING
        cancelUserListener()
        const currentApps = state.apps
        if (!_.isEmpty(currentApps)) {
          console.log('currentApps is not empty', currentApps)
          for (const appId in currentApps) {
            console.log('move app', appId)
            yield ref.child('users').child(authData.uid).child('apps').child(appId).set(currentApps[appId])
          }
        }
        // Remove anonymous user record
        yield ref.child('users').child(oldAuthData.id).set(null)
      }

      // console.log('auth ok', authData)
      const user = {
        id: authData.uid,
        name: authData.displayName,
        email: authData.email,
        isAnonymous: _.get(auth, 'currentUser.isAnonymous')
      }
      yield ref.child('users').child(authData.uid).update(user)
      try {
        // console.log('set createdAt !!!')
        yield ref.child('users').child(authData.uid).child('createdAt').set(firebase.database.ServerValue.TIMESTAMP)
      } catch (e) {
        // console.log('set createdAt', e)
      }
      dispatch(fetchUser(authData.uid))
      dispatch(authDataAction(user))
      dispatch(fetchPlans())
      // console.log('currentLocation', location)
      if (history.location.pathname === '/auth') {
        if (_.isNil(state.lastApp)) {
          history.push('/dashboard')
        } else {
          history.push(`/app/${state.lastApp}`)
          dispatch(setLastApp(null))
        }
      }
    } else {
      // console.log('user is not authorized')
      // dispatch(authDataAction({}))
      // cancelUserListener()
      // dispatch(logoutAction())
      dispatch(setInitialized())
      const state = getState()
      if (state.authData.initializing && history.location.pathname === '/dashboard') {
        console.log('Initializing, authAnonymously')
        dispatch(authAnonymously())
      }
      // if (history.location.pathname !== '/shopify-app') {
      //   dispatch(authAnonymously())
      // }
    }
  } catch (e) {
    console.log('onAuthStateChanged error', e)
  }
}


export function appInitialized () {
  return function * (dispatch, getState) {
    ref.child('references').on('value', (referencesSN) => {
      const references = referencesSN.val()
      if (references) {
        dispatch(receiveReferences(references))
      }
    })

    auth.onAuthStateChanged((authData) => {
      co(onAuthStateChanged(authData, dispatch, getState))

    })
  }
}



// WEBPACK FOOTER //
// ./src/controllers/init.js